<h2>Holdback Bank</h2>
<div>
  <p><strong>Pending:</strong> {{ totals.pending | currency }}</p>
  <p><strong>Released:</strong> {{ totals.released | currency }}</p>
  <p><strong>Forfeited:</strong> {{ totals.forfeited | currency }}</p>
  <br />
</div>

<nz-tabset>
  <nz-tab nzTitle="Pending">
    <nz-table [nzData]="pending" [nzShowPagination]="false">
      <thead><tr><th>Amount</th><th>WO</th><th>Planned Release</th></tr></thead>
      <tbody>
        <tr *ngFor="let h of pending">
          <td>{{ h.holdback_amount }}</td>
          <td>{{ h.work_order_id }}</td>
          <td>{{ h.planned_release_date | date }}</td>
        </tr>
      </tbody>
    </nz-table>
  </nz-tab>
  <nz-tab nzTitle="Released">
    <nz-table [nzData]="released" [nzShowPagination]="false">
      <thead><tr><th>Amount</th><th>Released</th></tr></thead>
      <tbody>
        <tr *ngFor="let h of released">
          <td>{{ h.holdback_amount }}</td>
          <td>{{ h.released_at | date }}</td>
        </tr>
      </tbody>
    </nz-table>
  </nz-tab>
  <nz-tab nzTitle="Forfeited">
    <nz-table [nzData]="forfeited" [nzShowPagination]="false">
      <thead><tr><th>Amount</th><th>Reason</th><th>Date</th></tr></thead>
      <tbody>
        <tr *ngFor="let h of forfeited">
          <td>{{ h.holdback_amount }}</td>
          <td>{{ h.release_reason }}</td>
          <td>{{ h.forfeited_at | date }}</td>
        </tr>
      </tbody>
    </nz-table>
  </nz-tab>
</nz-tabset>


